import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutSvg',
  props: {
  width: {
    type: [String, Number],
    default: 37,
  },
  height: {
    type: [String, Number],
    default: 55,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 37 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M0.000488281 3.99121C0.000488281 1.66894 2.52602 0.226768 4.52588 1.40723L7.06396 2.90527H26.8159L26.9702 2.90918C28.5552 2.98965 29.8159 4.3003 29.8159 5.90527V21.0938H27.8159V5.90527C27.8159 5.3874 27.4219 4.96119 26.9175 4.91016L26.8159 4.90527H10.4526L19.2192 10.0801C20.1333 10.6196 20.6938 11.6026 20.6938 12.6641V43.6084H26.8159C27.3679 43.6082 27.8157 43.1604 27.8159 42.6084V29.792H29.8159V42.6084L29.812 42.7627C29.7341 44.2965 28.504 45.5266 26.9702 45.6045L26.8159 45.6084H20.6938V51.3555C20.6936 53.6924 18.1394 55.1322 16.1401 53.9219L1.44678 45.0264C0.549048 44.4829 0.000615168 43.5094 0.000488281 42.46V3.99121Z",
      fill: __props.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M32.5998 19.5117C32.9134 19.5118 33.2086 19.6593 33.3967 19.9102L36.7991 24.4473C37.0657 24.8028 37.0657 25.2919 36.7991 25.6475L33.3967 30.1846C33.2086 30.4352 32.9133 30.5829 32.5998 30.583C31.7788 30.583 31.3103 29.6451 31.803 28.9883L33.9289 26.1533H26.0715C25.5192 26.1533 25.0715 25.7056 25.0715 25.1533V24.9395C25.0715 24.3872 25.5192 23.9395 26.0715 23.9395H33.928L31.803 21.1055C31.3103 20.4486 31.7788 19.5117 32.5998 19.5117Z",
      fill: __props.fill
    }, null, 8, _hoisted_3)
  ], 16, _hoisted_1))
}
}

})